import { render } from "./ContactUsView.vue?vue&type=template&id=24a5b9fb"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__